import { toHTML } from "@portabletext/to-html";
import { AccordionFAQProps } from "@bluebottlecoffee/design-system/components";
import { AccordionFaq as Schema } from "../sanity-schema";

export function toAccordionFaqProps(
  data: Schema,
  lang: string,
): AccordionFAQProps {
  return {
    caption: data.caption[lang],
    heading: data.heading[lang],
    ...(data.bgColor && { bgColor: data.bgColor }),
    items: data.items.map((item) => ({
      question: item.question[lang],
      answer: toHTML(item.answer[lang]),
    })),
  };
}
